<template>
  <div class="dashboard-widget-content">
    <template v-if="!value.ShowOptions">
      <chart-card-dashboard-wings no-footer :data="ChartData">
        <pie-chart :data="ChartData"></pie-chart>
      </chart-card-dashboard-wings>
    </template>
    <template v-else>
      <widget-options>
        <md-field>
          <label>{{ $t('widget.options.update') }}</label>
          <md-select v-model="options.update">
            <md-option value="10">10 {{ $t('widget.options.min') }}</md-option>
            <md-option value="0">{{ $t('widget.options.no') }}</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.interval') }}</label>
          <md-select v-model="options.interval">
            <md-option value="hour">{{ $t('widget.options.hour') }}</md-option>
            <md-option value="today">{{ $t('widget.options.today') }}</md-option>
            <md-option value="yesterday">{{ $t('widget.options.yesterday') }}</md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.chanel') }}</label>
          <md-select v-model="options.chanel">
            <md-option v-for="transport in this.$store.getters.transports" :value="transport.name" :key="transport.id">
              {{ transport.name }}
            </md-option>
          </md-select>
        </md-field>
        <md-field>
          <label>{{ $t('widget.options.group_by') }}</label>
          <md-select v-if="options.chanel == 'Push'" v-model="options.group_by">
            <md-option value="partner">{{ $t('widget.MessagesByGroup.options.group_by.partner') }}</md-option>
            <md-option value="application">{{ $t('widget.MessagesByGroup.options.group_by.application') }}</md-option>
            <md-option value="os">{{ $t('widget.MessagesByGroup.options.group_by.os') }}</md-option>
          </md-select>
          <md-select v-else v-model="options.group_by">
            <md-option value="service_provider">{{ $t('widget.MessagesByGroup.options.group_by.service_provider') }}</md-option>
            <md-option value="partner">{{ $t('widget.MessagesByGroup.options.group_by.partner') }}</md-option>
          </md-select>
        </md-field>
      </widget-options>
    </template>
  </div>
</template>

<script>
import widgetMixin from './mixin'
import { DateTime } from 'luxon'
import {MessagesByGroup} from "@/services/Widgets";

export default {
  name: "MessagesByGroup",
  mixins:[widgetMixin],
  props:{
    value:{},
    fullSize:{default:false}
  },
  data(){return{
    options:{
      update:'10',
      interval:'hour',
      chanel:'SMS',
      group_by:'partner',
      date_from: '',
      date_to: '',
    },
    ChartData: [],
  }},
  methods:{
    title() {
      let title = this.$t('widget.channel.'+this.options.chanel)+' '+ this.$t('widget.MessagesByGroup.options.group_by.'+this.options.group_by);

      switch (this.options.interval) {
        case 'hour':
          title +=  ` ${this.$t('widget.options.from')} ${DateTime.fromISO(this.options.date_from).toFormat('HH:mm')}`;
          title +=  ` ${this.$t('widget.options.to')} ${DateTime.fromISO(this.options.date_to).toFormat('HH:mm')}`;
          break;
        case 'today':
          title +=  ` ${this.$t('widget.options.today')}`;
          break;
        case 'yesterday':
          title +=  ` ${this.$t('widget.options.yesterday')}`;
          break;
      }
      return title;
    },
    async getData() {
      switch (this.options.interval) {
        case 'hour':
          this.options.date_from = DateTime.local().plus({hour:-1}).toISO();
          this.options.date_to = DateTime.local().toISO();
          break;
        case 'today':
          this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
          this.options.date_to = DateTime.local().set({second: 0, millisecond: 0}).toISO();
          break;
        case 'yesterday':
          this.options.date_from = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).plus({day: -1}).toISO();
          this.options.date_to = DateTime.local().set({hour: 0, minute: 0, second: 0, millisecond: 0}).toISO();
          break;
      }

      let filter = {
        date_from: this.options.date_from,
        date_to: this.options.date_to,
        transport: this.options.chanel,
        group_by: this.options.group_by,
        message_direction: 'mt',
      };

      let response = await MessagesByGroup(filter);
      // response.data = [{"service_provider":"Provider1","total":7},{"service_provider":"Yota","total":8}];
      if (response.data) {
        let chartData = [];

        response.data.messages.forEach((item) => {
          chartData.push({
            name: item[this.options.group_by],
            value: item.total,
          });
        })

        this.ChartData = chartData;
      }

      this.updateTitle();
    },
    intervalFunc() {
      clearInterval(this.timer);
      const update = (60000 * parseInt(this.options.update)) || 0;
      if (update > 0) {
        this.getData();
        this.timer = setInterval(() => this.getData(), update);
      }
    }
  },
  watch: {
    'options'() {
      this.intervalFunc();
    },
    'options.chanel'(val) {
      if (val == 'Push') {
        this.options.group_by = 'partner';
      }
    }
  },
  mounted() {
    this.intervalFunc();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
}
</script>
